// extracted by mini-css-extract-plugin
module.exports = {"modal":"BrowserNotice_modal__27Rqi","close":"BrowserNotice_close__b1TEq"};